import { render } from "./DefaultFooterLayout.vue?vue&type=template&id=2e01b23a"
const script = {}

import exportComponent from "/html/rinke-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__